<template>
  <div class="chart__conyainer">
    <div class="chart__users">
      <div
        class="chart__users-item user-avatar"
        v-for="(user, index) in trimUsers"
        :key="`${index} user`"
      >
        <img v-if="user.avatar" :src="user.avatar.url" />
        <img v-else src="/img/avatar-thumb.png" />
      </div>
      <button v-if="trimCount < users.length" @click="trimCount = users.length">...</button>
    </div>

    <div class="chart custom-scrollbar" ref="chart" @scroll="loadMore">
      <div
        class="chart__day"
        v-for="(day, dayIndex) in days"
        :key="`${dayIndex} day`"
        :style="`width: ${widthChartDay}px; margin-right: ${marginRight}px`"
      >
        <h3 class="chart__day-name">{{ convertDate(day) }}</h3>
        <div class="chart__day-hours">
          <span class="hours__item" v-for="hour in 9" :key="`${hour} hour`">
            <span class="hours__item-name">{{ `1${hour}:00` }}</span>
            <span
              class="hour__item-user-busy"
              v-for="(user, userIndex) in trimUsers"
              :key="`${userIndex} users`"
            >
              <span v-if="isHaveBusy(user.id, day)">
                <span
                  v-for="(busy, i) in getBusyInHour(user.id, day, '1' + hour)"
                  :key="i + 'busy'"
                  class="busy"
                  :style="getPeriod('1' + hour, busy)"
                />
              </span>
              <span class="delimiter" />
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import axios from "@/utils/axios";
import { config } from "@/store/index";

export default {
  props: {
    users: {
      type: Array,
      default: () => []
    },
    date: {
      type: Date,
      default: () => new Date()
    }
  },
  mounted() {
    this.getMonthData();
  },
  data() {
    return {
      days: [],
      widthChartDay: 517,
      marginRight: 24,
      loadRightMonth: 0,
      loadLeftMonth: 0,
      trimCount: 4,

      shownPeriod: {},
      usersBusyTime: {}
    };
  },
  computed: {
    month() {
      return this.date.getMonth();
    },
    year() {
      return this.date.getFullYear();
    },
    dayNumber() {
      return this.date.getDate();
    },
    trimUsers() {
      return this.users.slice(0, this.trimCount);
    },
    isHaveBusy() {
      return (userId, day) => {
        if (!this.days.length) return false;

        const date = this.formatDate(day);

        if (this.usersBusyTime[userId] && this.usersBusyTime[userId][date]) {
          return true;
        }

        return false;
      };
    }
  },
  methods: {
    convertDate(date) {
      return moment(date)
        .locale("ru")
        .format("DD MMMM, dddd");
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    daysInMonth(year, month) {
      return new Date(year, month, 0).getDate();
    },
    getMonthData(newDate, loadType) {
      let dateStart;
      let dateEnd;

      // if (loadType === "shown" && Object.keys(this.shownPeriod)) {
      //   dateStart = moment(this.shownPeriod.start).format("DD-MM-YYYY");
      //   dateEnd = moment(this.shownPeriod.end)
      //     .endOf("month")
      //     .format("DD-MM-YYYY");
      // } else {
      const date = newDate || new Date(this.year, this.month, 1);
      dateStart = moment(date).format("DD-MM-YYYY");
      dateEnd = moment(date)
        .endOf("month")
        .format("DD-MM-YYYY");
      // }

      const params = {
        "search[type]": "Activity",
        expand: "itemable,users",
        "search[from_date]": dateStart,
        "search[to_date]": dateEnd,
        // "search[users]": this.trimUsers?.map(user => user.id)?.join(","),
        "per-page": 1000,
        sort: '-created_at'
      };

      axios.get("/event-posts", { params, ...config }).then(res => {
        const usersBusyTime = JSON.parse(JSON.stringify(this.usersBusyTime));

        res.data.data.forEach(({ itemable }) => {
          itemable?.users.forEach(user => {
            if (!usersBusyTime[user.id]) usersBusyTime[user.id] = {};

            const userId = user.id;
            const start = itemable?.["start_at"].split(" ");
            const end = itemable?.["end_at"].split(" ");
            const dayEvents = usersBusyTime[userId][start[0]];
            const periodEvent = `${start[1]}-${end[1]}`;

            if (
              dayEvents &&
              (dayEvents === periodEvent || dayEvents.includes(periodEvent))
            ) {
              return;
            }

            if (dayEvents) {
              if (dayEvents instanceof Array) dayEvents.push(periodEvent);
              else usersBusyTime[userId][start[0]] = [dayEvents, periodEvent];
            } else {
              if (start[0] === end[0]) {
                usersBusyTime[userId][start[0]] = [periodEvent];
              } else {
                console.error("Мероприятие не должно идти больше 1 дня");
              }
            }
          });
        });
        this.usersBusyTime = usersBusyTime;
      });

      if (!loadType) {
        const days = [];
        for (
          let day = 1;
          day <= this.daysInMonth(this.year, this.month);
          day++
        ) {
          days.push(new Date(this.year, this.month, day));
        }

        this.days = days;
      } else if (loadType === "next") {
        this.days = [...this.days, ...this.createNewMonth(newDate)];
      } else if (loadType === "prev") {
        this.days = [...this.createNewMonth(newDate), ...this.days];
      }

      if (!newDate && loadType !== "shown") {
        this.$nextTick(() => {
          if (this.dayNumber === 1) {
            this.$refs.chart.scrollLeft = 1;
          } else {
            this.$refs.chart.scrollLeft =
              (this.widthChartDay + this.marginRight) * (this.dayNumber - 1);
          }
        });
      }
    },
    loadMore({ target }) {
      if (target.scrollLeft + target.clientWidth === target.scrollWidth) {
        this.loadRightMonth += 1;
        let newDate = new Date(this.year, this.month, 1);
        newDate = new Date(
          newDate.setMonth(newDate.getMonth() + this.loadRightMonth)
        );

        // this.shownPeriod.end = newDate;
        this.getMonthData(newDate, "next");
      } else if (target.scrollLeft === 0) {
        this.loadLeftMonth += 1;
        let newDate = new Date(this.year, this.month, 1);
        newDate = new Date(
          newDate.setMonth(newDate.getMonth() - this.loadLeftMonth)
        );

        // this.shownPeriod.start = newDate;
        this.getMonthData(newDate, "prev");

        this.$nextTick(() => {
          this.$refs.chart.scrollLeft =
            (this.widthChartDay + this.marginRight) *
            this.daysInMonth(newDate.getFullYear(), newDate.getMonth());
        });
      }
    },
    createNewMonth(date) {
      const newMonth = [];

      for (
        let day = 1;
        day <= this.daysInMonth(date.getFullYear(), date.getMonth());
        day++
      ) {
        newMonth.push(new Date(date.getFullYear(), date.getMonth(), day));
      }

      return newMonth;
    },
    getPeriod(hour, time) {
      const defaultLeft = 50;
      const style = {
        width: "0%",
        left: defaultLeft + "%",
        zIndex: 1
      };

      const period = time.split("-");
      const timeStart = period[0].split(":");
      const timeEnd = period[1].split(":");

      if (timeStart[0] < hour && timeEnd[0] > hour) {
        style.width = "100%";
      } else if (timeStart[0] === hour && timeEnd[0] === hour) {
        (style.width = ((timeEnd[1] - timeStart[1]) * 100) / 60 + "%"),
          (style.left = (timeStart[1] * 100) / 60 + defaultLeft + "%");
      } else if (timeStart[0] === hour) {
        style.width = ((60 - timeStart[1]) * 100) / 60 + "%";
        style.left = (timeStart[1] * 100) / 60 + defaultLeft + "%";
      } else if (timeEnd[0] === hour) {
        style.width = (timeEnd[1] * 100) / 60 + "%";
      }

      return style;
    },
    getBusyInHour(userId, day, hour) {
      const busy = this.usersBusyTime[userId][this.formatDate(day)].filter(
        time => {
          const splitTime = time.split("-");
          const start = splitTime[0].split(":")[0];
          const end = splitTime[1].split(":")[0];
          return start === hour || end === hour || (start < hour && end > hour);
        }
      );
      return busy;
    }
  },
  watch: {
    "trimUsers.length"() {
      this.getMonthData(null, "shown");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/system/_vars";
@import "@/assets/css/system/_mixins";

.chart__conyainer {
  position: relative;
  width: 100%;
  display: flex;
}

.chart__users {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  padding-top: 83px;
  width: 47px;
  // max-height: 235px;
  background: white;
  z-index: 10;

  .chart__users-item {
    max-width: 24px;
    max-height: 24px;
    margin: 0 auto 15px;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 10px;
    color: gray;
    font-size: 20px;
    cursor: pointer;
  }
}

.chart {
  display: flex;
  width: 100%;
  height: 100%;
  max-width: 683px;
  // max-height: 250px;
  padding-left: 47px;
  overflow-x: auto;

  .chart__day {
    display: flex;
    flex-direction: column;
    // width: 517px;
    height: 100%;
    // margin-right: 24px;

    &:last-of-type {
      margin-right: 0;
    }

    .chart__day-name {
      font-weight: bold;
      color: $font_color_third;
      font-size: 18px;
      margin-bottom: 18px;
      text-transform: capitalize;
    }

    .chart__day-hours {
      display: flex;
      width: 100%;

      .hours__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #697178;
        width: 61px;

        .hours__item-name {
          margin-bottom: 15px;
        }

        .hour__item-user-busy {
          display: flex;
          justify-content: center;
          width: 100%;
          height: 21px;
          background: #f3f5ff;
          margin-bottom: 18px;
          position: relative;

          .busy {
            display: block;
            position: absolute;
            background: rgba(192, 16, 130, 0.6);
            height: 100%;
          }

          .delimiter {
            background: #bfbfbf;
            width: 1px;
            height: 200%;
            margin: -10px;
          }
        }
      }
    }
  }
}
</style>
